import { AlertCircle, RefreshCw } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { Button } from "../ui/button";
import {
  SOAP_GENERATION_FAILED_AGAIN_BODY,
  SOAP_GENERATION_FAILED_BODY,
  SOAP_GENERATION_FAILED_TITLE,
} from "../../utils/soapGenerationFailure";

export default function SoapGenerationFailedModal({
  isOpen,
  onClose,
  onRegenerate,
  isRegenerating = false,
  failedAgain = false,
}) {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open && !isRegenerating) onClose?.();
      }}
    >
      <DialogContent
        className="sm:max-w-md"
        onPointerDownOutside={(event) => {
          if (isRegenerating) event.preventDefault();
        }}
        onEscapeKeyDown={(event) => {
          if (isRegenerating) event.preventDefault();
        }}
      >
        <DialogHeader className="text-center sm:text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
            <AlertCircle className="h-8 w-8 text-red-600" />
          </div>
          <DialogTitle className="text-xl font-bold text-gray-900">
            {SOAP_GENERATION_FAILED_TITLE}
          </DialogTitle>
          <DialogDescription className="text-gray-600">
            {failedAgain
              ? SOAP_GENERATION_FAILED_AGAIN_BODY
              : SOAP_GENERATION_FAILED_BODY}
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col-reverse gap-2 pt-2 sm:flex-row sm:justify-end">
          <Button
            type="button"
            variant="outline"
            onClick={onClose}
            disabled={isRegenerating}
          >
            Close
          </Button>
          <Button
            type="button"
            onClick={onRegenerate}
            disabled={isRegenerating}
            className="bg-blue-600 hover:bg-blue-700 text-white"
          >
            {isRegenerating ? (
              <>
                <RefreshCw className="h-4 w-4 animate-spin" />
                Regenerating…
              </>
            ) : (
              <>
                <RefreshCw className="h-4 w-4" />
                Regenerate SOAP Note
              </>
            )}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
